//* Hooks
import { useState, useEffect} from 'react'
import { useParams } from 'react-router-dom'

//* API
import { fetchFromAPI } from '../utils/fetchFromAPI'

//* Components
import { Box, Typography } from '@mui/material'
import { Videos } from './'

const SearchFeed = () => {

  const [videos, setVideos] = useState([])
  const { searchTerm } = useParams()

  useEffect(() => {
    fetchFromAPI(`search?part=snippet&q=${searchTerm}`)
    .then((data) => {setVideos(data.items)})
  },[searchTerm])

  return (
    <Box p={2} sx={{ overflowY: 'auto' }}>
        <Typography variant='h4' fontWeight='bold' mb={2} sx={{
          color: 'white'
        }}>
          
          Search Results for: <span style={{ color: '#F31503'}}> {searchTerm} </span> videos
        </Typography>

        <Videos videos={videos} />
      </Box>
  )
}

export default SearchFeed